import { render, staticRenderFns } from "./ClassStudent.vue?vue&type=template&id=d56e9804&scoped=true"
import script from "./ClassStudent.vue?vue&type=script&lang=js"
export * from "./ClassStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e9804",
  null
  
)

export default component.exports